// import { Button, message } from "antd";
// import { AlertTriangle, LogOut } from "lucide-react";
// import { useUserStore } from "@/stores/userStore";

// const ImpersonationBar: React.FC = () => {
//   const user = useUserStore((s) => s.user);
//   const superAdminStore = useUserStore((s) => s.superAdminStore);
//   const exitImpersonation = useUserStore((s) => s.exitImpersonation);
//   const superAdminUser = superAdminStore?.user;
//   const impersonatedUser = user;

//   if (!superAdminUser || !impersonatedUser) return null;

//   const handleExit = () => {
//     exitImpersonation();
//     message.success("Exited impersonation mode");
//   };

//   return (
//     <div
//       role="alert"
//       aria-live="polite"
//       className="flex h-16 items-center justify-between pag-2 shadow-sm bg-amber-100 px-4 lg:px-6 shrink-0"
//     >
//       <div className="flex items-center gap-3 flex-1 min-w-0">
//         <div className="p-1">
//           <AlertTriangle className="h-5 w-5 shrink-0 text-amber-600" aria-hidden="true" />
//         </div>
//         <div className="flex flex-col gap-0.5 min-w-0">
//           <p className="text-sm font-medium text-amber-900 truncate">
//             Acting as: <span className="font-semibold">{impersonatedUser.firstName || impersonatedUser.email}</span>{" "}
//             <span className="text-amber-700">({impersonatedUser.email})</span>
//           </p>
//           <p className="text-xs text-amber-700 truncate">
//             Logged in by {superAdminUser.firstName || superAdminUser.email} (Super Admin)
//           </p>
//         </div>
//       </div>
//       <Button type="primary" danger icon={<LogOut size={16} />} onClick={handleExit}>
//         Exit
//       </Button>
//     </div>
//   );
// };

// export default ImpersonationBar;



import { Button, message } from "antd";
import { AlertTriangle, LogOut } from "lucide-react";
import { useUserStore } from "@/stores/userStore";

const ImpersonationBar: React.FC = () => {
  const user = useUserStore((s) => s.user);
  const superAdminStore = useUserStore((s) => s.superAdminStore);
  const adminStore = useUserStore((s) => s.adminStore);
  const exitImpersonation = useUserStore((s) => s.exitImpersonation);

  const isImpersonating = !!superAdminStore || !!adminStore;

  // Determine who initiated the impersonation
  // If adminStore exists, the admin is impersonating (possibly through super admin → admin → user)
  // If only superAdminStore exists, the super admin is impersonating directly
  const impersonator = adminStore?.user || superAdminStore?.user;
  const impersonatorRole = adminStore ? "Admin" : "Super Admin";
  const impersonatedUser = user;

  if (!isImpersonating || !impersonator || !impersonatedUser) return null;

  const handleExit = () => {
    exitImpersonation();
    if (adminStore) {
      message.success("Exited impersonation mode — returned to Admin view");
    } else {
      message.success("Exited impersonation mode — returned to Super Admin view");
    }
  };

  return (
    <div
      role="alert"
      aria-live="polite"
      className="flex h-16 items-center justify-between pag-2 shadow-sm bg-amber-100 px-4 lg:px-6 shrink-0"
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className="p-1">
          <AlertTriangle className="h-5 w-5 shrink-0 text-amber-600" aria-hidden="true" />
        </div>
        <div className="flex flex-col gap-0.5 min-w-0">
          <p className="text-sm font-medium text-amber-900 truncate">
            Acting as: <span className="font-semibold">{impersonatedUser.firstName || impersonatedUser.email}</span>{" "}
            <span className="text-amber-700">({impersonatedUser.email})</span>
          </p>
          <p className="text-xs text-amber-700 truncate">
            Logged in by {impersonator.firstName || impersonator.email} ({impersonatorRole})
            {adminStore && superAdminStore && (
              <span> · via {superAdminStore.user?.firstName || superAdminStore.user?.email} (Super Admin)</span>
            )}
          </p>
        </div>
      </div>
      <Button type="primary" danger icon={<LogOut size={16} />} onClick={handleExit}>
        Exit
      </Button>
    </div>
  );
};

export default ImpersonationBar;